import { ConfirmationDialog, ErpDataTableV2 } from '@/components/custom/erp';
import type { LoaiTSCDCCDC, LoaiTSCDCCDCInput } from '@/types/schemas';
import { getDataTableColumns } from './cols-definition';
import { ActionBar, FormDialog } from './components';
import { useCRUD, useForms } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

export default function LyDoNhapXuatPage() {
  const { addItem, updateItem, deleteItem, refreshData, isLoading, data, fetchDetail } = useCRUD<
    LoaiTSCDCCDC,
    LoaiTSCDCCDCInput
  >({
    endpoint: QUERY_KEYS.LOAI_TSCD_CCDC
  });

  const {
    showForm,
    showDelete,
    selectedObj,
    selectedRowIndex,
    formMode: mode,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<LoaiTSCDCCDC>(fetchDetail);

  const handleSubmit = async (data: LoaiTSCDCCDCInput) => {
    try {
      if (mode === 'add') {
        await addItem(data);
      } else if (mode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      handleCloseForm();
      clearSelection();
    } catch (err: unknown) {
      console.error('Error submitting form:', err);
    }
  };

  const tables = [
    {
      name: '',
      rows: data,
      columns: getDataTableColumns()
    }
  ];
  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {showForm && (
        <FormDialog
          mode={mode}
          open={showForm}
          onClose={handleCloseForm}
          onAddButtonClick={handleAddClick}
          onEditButtonClick={handleEditClick}
          onCopyButtonClick={handleCopyClick}
          onWatchButtonClick={handleViewClick}
          onDeleteButtonClick={handleDeleteClick}
          onSubmit={handleSubmit}
          initialData={mode === 'add' && !isCopyMode ? undefined : selectedObj}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={handleAddClick}
          onEditIconClick={handleEditClick}
          onDeleteIconClick={handleDeleteClick}
          onCopyIconClick={handleCopyClick}
          onWatchIconClick={handleViewClick}
          onRefreshClick={refreshData}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>

      {showDelete && (
        <ConfirmationDialog
          onClose={handleCloseDelete}
          onConfirm={() => {
            deleteItem(selectedObj!.uuid);
            handleCloseDelete();
            clearSelection();
            handleCloseForm();
          }}
        />
      )}
    </div>
  );
}
